import React, { Component } from 'react';
import cn from 'classnames/bind';
import styles from './Dropdown.scss';
import AngleDown from 'react-icons/lib/fa/angle-down';
import onClickOutside from 'react-onclickoutside';

const cx = cn.bind(styles);

class Dropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isVisible: false,
    };

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.hideMenu = this.hideMenu.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  showMenu = (allowClose) => {
    const { disabled } = this.props;

    if (disabled) {
      return;
    }

    if (this.props.onShow) {
      this.props.onShow();
    }
    if (!this.state.isVisible) {
      this.setState({ isVisible: true, allowClose });
    }
  };

  hideMenu() {
    if (this.state.isVisible) {
      this.setState({ isVisible: false, allowClose: false });
    }
  }

  onMouseEnter(e) {
    // TODO Нужно убрать этот костыль и сделать как-то более красивше функционал
    // с показом и сокрытием меню
    setTimeout(this.showMenu, 100);
    setTimeout(() => {
      this.setState({ allowClose: true });
    }, 400);
  }

  onMouseLeave(e) {
    setTimeout(this.hideMenu, 100);
  }

  onClick() {
    // const { isVisible } = this.state;
    const { onClick, disabled } = this.props;

    if (disabled) {
      return;
    }

    if (onClick) {
      onClick();
    }

    if (this.state.isVisible && this.state.allowClose) {
      this.hideMenu();
    } else {
      this.showMenu(true);
    }
  }

  handleClickOutside(e) {
    if (this.state.isVisible) {
      this.hideMenu();
    }
  }

  componentWillUnmount() {
    this.hideMenu();
  }

  render() {
    const {
      className,
      buttonStyle,
      textStyle,
      dropdownMenuStyle,
      subtextStyle,
      text,
      subtext,
      additionalCount,
      icon,
      iconStyle,
      fixed,
      rightShift,
      topShift,
      leftShift,
      filter,
      openByClick,
      chessfilter = true,
      onClick,
      disabled,
      ...restProps
    } = this.props;
    const { isVisible } = this.state;

    return (
      <div
        className={cx(
          className,
          styles.Dropdown,
          { [styles.DropdownChessfilter]: chessfilter },
          { [styles[chessfilter]]: chessfilter },
          { [styles.Filter]: filter }
        )}
        onMouseLeave={!openByClick ? this.onMouseLeave : null}
        {...restProps}
      >
        <div
          className={cx(buttonStyle, styles.Button)}
          onMouseEnter={!openByClick && !disabled ? this.onMouseEnter : null}
          onClick={this.onClick}
        >
          <div className={styles.Text_Container}>
            {text ? (
              <p className={cx(textStyle, styles.Text, { [styles.Active]: this.state.isVisible })}>
                {text}{' '}
                {additionalCount ? (
                  <span className={styles.AdditionalCount}>{additionalCount}</span>
                ) : null}
              </p>
            ) : null}
            {subtext ? <p className={cx(subtextStyle, styles.Subtext)}>{subtext}</p> : null}
          </div>
          {icon ? (
            icon === 'custom' ? (
              <i className={iconStyle}></i>
            ) : (
              <img src={icon} alt="" className={cx(iconStyle, styles.Icon)} />
            )
          ) : (
            <AngleDown
              className={cx(iconStyle, styles.Icon, { [styles.Active]: this.state.isVisible })}
            />
          )}
        </div>
        {isVisible ? (
          <div
            ref={this.getMenu}
            className={cx(
              styles.Menu,
              { Fixed: fixed, RightShift: rightShift, TopShift: topShift, LeftShift: leftShift },
              styles[dropdownMenuStyle]
            )}
          >
            {this.props.children || <div>Example</div>}
          </div>
        ) : null}
      </div>
    );
  }
}

export default onClickOutside(Dropdown);



// WEBPACK FOOTER //
// ./src/components/common/Dropdown/Dropdown.js